module.exports = __webpack_public_path__ + "img/blue-whale.d4c160b1.jpg";